<template>
  <div>
    <el-breadcrumb separator="/" style="padding-bottom: 10px;">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>地址列表</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="table">
      <div class="top">
        <div>
          <el-button type="primary" @click="add" size="mini" icon="el-icon-plus" v-if="addressCreateStatus=='true'">新增
          </el-button>
        </div>
      </div>
      <div class="content">
        <el-table :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }"
                  :data="tableData" border
                  style="width: 100%;" size="mini">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="phone" label="用户手机"></el-table-column>
          <el-table-column prop="nikeName" label="收件人"></el-table-column>
          <el-table-column prop="address" label="地址"></el-table-column>
          <el-table-column prop="defaultAddress" label="默认地址">
            <template slot-scope="scope">
              <span v-if="scope.row.defaultAddress==0">非默认</span>
              <span v-if="scope.row.defaultAddress==1">默认</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="dialog(scope.row)" size="small" v-if="addressUpdateStatus=='true'">编辑
              </el-button>
              <el-button style="color: #FF0000;" @click="remove(scope.row.id)" type="text"
                         size="small" v-if="addressDeleteStatus=='true'">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="bottom">
        <el-pagination @size-change="handleSizeChange" @current-change="changePage"
                       :current-page="queryData.pageNo"
                       :page-sizes="[15, 25, 40, 50]" :page-size="queryData.size"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total" style="float: right;">
        </el-pagination>
      </div>
    </div>
    <el-dialog
        title="新增/编辑"
        :visible.sync="dialogVisible"
        width="50%">
      <span>
        <el-form ref="formValidate" :model="address" size="mini" label-width="150px" class="demo-ruleForm"
                 :rules="ruleValidate">
          <el-form-item label="用户手机" prop="phone" style="width: 85%">
            <el-input v-model="address.phone" placeholder="请输入用户手机"></el-input>
          </el-form-item>
          <el-form-item label="收件人" prop="nikeName" style="width: 85%">
            <el-input v-model="address.nikeName" placeholder="请输入收件人名称"></el-input>
          </el-form-item>
           <el-form-item label="默认地址" pro="defaultAddress">
              <el-radio-group v-model="address.defaultAddress">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
           <el-form-item label="影院地址" prop="address" style="width: 85%">
              <el-input type="textarea" :rows="2" v-model="address.address" placeholder="必须填写 影院名称 + 影院的详细地址，其他地址无效"></el-input>
            </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
         <el-button size="small" @click="dialogVisible = false" style="float:left">取 消</el-button>
         <el-form ref="queryData" :model="address" label-width="100px" size="mini">
            <el-button size="small" type="primary" @click="create('formValidate')" v-if="address.mode==0">保存</el-button>
            <el-button size="small" type="primary" @click="update('formValidate')" v-if="address.mode==1">修改</el-button>
         </el-form>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import router from "../../router";
import {
  addressList,
  createAddress,
  updateAddress,
  deleteAddress
} from "../../request/api.js";

export default {
  data() {
    return {
      total: 1,
      addressCreateStatus: window.sessionStorage.getItem('addressCreateStatus'),
      addressListStatus: window.sessionStorage.getItem('addressListStatus'),
      addressUpdateStatus: window.sessionStorage.getItem('addressUpdateStatus'),
      addressDeleteStatus: window.sessionStorage.getItem('addressDeleteStatus'),
      // addressCreateStatus:false,
      // addressListStatus:false,
      // addressUpdateStatus:false,
      // addressDeleteStatus:false,
      tableData: [],
      queryForm: {
        show: false,
      },
      queryData: {
        pageNo: 1,
        size: 15,
      },
      dialogVisible: false,
      address: {
        id: '',
        userId: '',
        phone: '',
        nikeName: '',
        defaultAddress: 0,
        address: '',
        mode: 0,
      },
      ruleValidate: {
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }],
        nikeName: [{
          required: true,
          message: '请输入电影院名称',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请输入地址',
          trigger: 'blur'
        }],
      },

    }
  },
  methods: {
    add() {
      this.address.id = "";
      this.address.address = "";
      this.address.defaultAddress = 0;
      this.address.phone = "";
      this.address.nikeName = "";
      this.address.userId = "";
      this.address.mode = 0;
      this.dialogVisible = true;
    },
    addressList() {
      let queryDataForm = this.queryData;
      addressList(queryDataForm).then((data) => {
        this.tableData = data.data.list;
        this.total = data.data.total;
      })
    },
    dialog(row) {
      this.address.id = row.id;
      this.address.address = row.address;
      this.address.defaultAddress = row.defaultAddress;
      this.address.phone = row.phone;
      this.address.nikeName = row.nikeName;
      this.address.userId = row.userId;
      this.address.mode = 1;
      this.dialogVisible = true;
    },
    create(name) {
      console.log(">>>>>>>>>>>>>> : name", name)
      this.$refs[name].validate((valid) => {
        if (valid) {
          createAddress(this.address).then((data) => {
            this.dialogVisible = false;
            if (data.data == true) {
              this.$message({
                message: data.msg,
                type: 'success'
              });
              this.addressList();
            }
          })
        } else {
          this.$Message.error('必填项有为空，请把为空的填上!');
        }
      })
    },
    update(name) {
      console.log(">>>>>>>>>>>>>> : name", name)
      this.$refs[name].validate((valid) => {
        if (valid) {
          updateAddress(this.address, this.address.id).then((data) => {
            this.dialogVisible = false;
            if (data.data == true) {
              this.$message({
                message: data.msg,
                type: 'success'
              });

              this.addressList();
            } else {
              this.$Message.error('更新失败了!');
            }
          })
        } else {
          this.$Message.error('必填项有为空，请把为空的填上!');
        }
      })
    },
    remove(id) {
      deleteAddress(id).then((data) => {
        if (data.code == 20000) {
          this.addressList();
        }
      })
    },
    handleSizeChange(a) {
      this.queryData.size = a;
      this.addressList()
    },
    changePage(page) {
      this.queryData.pageNo = page;
      this.addressList()
    },
  },
  created() {
    this.addressList();
  }
}
</script>

<style scoped>
.bottom {
  margin-top: 10px;
  padding-bottom: 25px;
}

.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}

.table {
  background: #FFF;
  padding: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  height: auto;
}

.top {
  margin-bottom: 10px;
}

.top-query {
}

.show-form {
  font-size: 10px;
  margin-left: 8px;
}

.el-icon-arrow-down {
  display: inline-block;
}
</style>
